/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Mar 26 2021 13:32:44 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.FINASSETS;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface AssetRVAmountResponse {
  rvid: number;
  mgid: number;
  assetid: number;
  prcode: string;
  assettype: string;
  assetcategory: string;
  assetamount: number;
  monthsmin: number;
  monthsmax: number;
  rvevaluationmode: string;
  rvfixedamount: number;
  rvpercentage: number;
  rvamount: number;
}

export interface FinAssetRequest {
  assetcategory: string;
  assetunitnetamount: number;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  finAssetComponents: Array<FinAssetComponent>;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  updated_by: number;
  updatedat: string;
  weight: string;
  assetfamily: string;
  assetsegment: string;
  catalogid: number;
  assetrvamount: number;
  listrv: Array<AssetRVAmountResponse>;
  networkcode: string;
  tpidbroker: number;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;

  brokername: string;
  brokerreference: string;
}

export interface GetFinAssetListByAnyRefParams {
  assetid?: number;
  assetreference?: string;
  assetlabel?: string;
  clientname?: string;
  clientreference?: string;
  ctreference?: string;
  deliveryreference?: string;
  orderreference?: string;
  propreference?: string;
  refsupplier?: string;
  status?: string;
  phase?: string;
  suppliername?: string;
  chassisno?: string;
  plateno?: string;
  assetclass?: string;
}

export interface IrvScheduleResponse {
  irvid: number;
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  accountingdate: string;
  accountingreference: string;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}

export interface FinAssetResponse {
  catalogid: number;
  assetexpdeliverydate: string;
  assetcategory: string;
  assetcategorylabel: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetmodellabel: string;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assetstatusdate: string;
  assettaxamount: number;
  assettype: string;
  assettypelabel: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  finAssetComponents: Array<FinAssetComponentResponse>;
  irvSchedule: Array<IrvScheduleResponse>;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  statuslabel: string;
  suppliername: string;
  supplierreference: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  updated_at: string;
  updated_by: number;
  weight: string;
  assetfamilylabel: string;
  assetfamily: string;
  assetsegmentlabel: string;
  assetsegment: string;
  networkcode: string;
  tpidbroker: number;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;
  assetqty: number;
  brokername: string;
  brokerreference: string;
  assettaggrouping: string;
  registrationcity: string;
  registrationdate: string;
  registrationname: string;
  firstregistrationdate: string;
  fiscalpower: any;
  assetpictureurl: string;
  assetmileage: number;
}

export interface FinAssetConElementResponse {
  assetid: number;
  associd: number;
  cteid: number;
  cteorder: number;
  ctestatus: string;
  ctestatuslabel: string;
  ctreference: string;
  ctrid: number;
  ctstatus: string;
  ctstatuslabel: string;
  endate: string;
  finamountin: number;
  finamountout: number;
  originalamount: number;
  startdate: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  propreference?: string;
  outstandingAmount: number;
}

export interface FinAsset {
  assetcategory: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assetstatusdate: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  finAssetComponents: Array<FinAssetComponent>;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  updated_at: string;
  updated_by: number;
  weight: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
}

export interface FinAssetComponent {
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  finAsset: FinAsset;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
}

export interface FinAssetComponentResponse {
  assetid: number;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  suppliername: string;
  supplierreference: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
}

export interface FinAssetDeprContextResponse {
  assetid: number;
  assetnetamount: number;
  assetrvamount: number;
  basisamount: number;
  coefficient: number;
  compcatexcluded: string;
  compexcludedamount: number;
  compid: number;
  complabel: string;
  comptypeexcluded: string;
  contextid: number;
  contextlabel: string;
  deprcontext: string;
  deprlevel: string;
  deprmethod: string;
  durationmonths: number;
  durationyear: number;
  enddate: string;
  finAssetDeprSchedules: Array<FinAssetDeprScheduleResponse>;
  methodlabel: string;
  startdate: string;
}

export interface FinAssetDeprScheduleResponse {
  accountingdate: string;
  accountingreference: string;
  assetid: number;
  basisstartamount: number;
  deprdegressiveamount: number;
  deprlinearamount: number;
  deprlineid: number;
  enddate: string;
  fiscalamountend: number;
  startdate: string;
}

export interface AssetComponentResponse {
  assetid: number;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  suppliername: string;
  supplierreference: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
}

export interface FinAssetListSearchResponse {
  assetComponents: Array<AssetComponentResponse>;
  assetqty: number;
  assetcategory: string;
  assetcategorylabel: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetfamily: string;
  assetfamilylabel: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetstatus: string;
  assetstatusdate: number;
  assettaxamount: number;
  taxcode: string;
  assettype: string;
  assettypelabel: string;
  clientname: string;
  clientreference: string;
  cteid: number;
  ctreference: string;
  ctrid: number;
  currcode: string;
  endate: string;
  finamountin: number;
  finamountout: number;
  irvamountout: number;
  originalamount: number;
  propreference: string;
  refsupplier: string;
  startdate: string;
  statuslabel: string;
  suppliername: string;
  tpidclient: number;
  tpidsupplier: number;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  chassisno: string;
  plateno: string;
}

export interface AssetFutureValues {
  assetid: number;
  contextcode: string;
  contextcodelabel: string;
  contextid: number;
  contextidorigine: number;
  contextidoriginlabel: string;
  finrvamount: number;
  fvamount: number;
  fvdate: string;
  fvtype: string;
  fvtypelabel: string;
  parcontextid: number;
}

export interface AssetDepreciationValues {
  assetid: number;
  assetnetamount: number;
  assetrvamount: number;
  assetvalueamount: number;
  assetvaluedate: string;
  basisamount: number;
  coefficient: number;
  contextid: number;
  deprcontext: string;
  deprcontextlabel: string;
  deprmethod: string;
  deprmethodlabel: string;
  durationmonths: number;
  durationyear: number;
  enddate: string;
  startdate: string;
}
export interface AssetValues {
  currcode: string;
  assetfinamount: number;
  assetfinrvamount: number;
  assetid: number;
  assetirvamount: number;
  assetlabel: string;
  assetnetamount: number;
  assetreference: string;
  assetrvamount: number;
  assetstatus: string;
  assetstatusdate: string;
  assetvaluesdate: string;
  deliverydate: string;
  depreciationValues: Array<AssetDepreciationValues>;
  futureValues: Array<AssetFutureValues>;
  marketvalue: number;
  marketvaluedate: string;
  marketvalueorigin: string;
  statuslabel: string;
  usevalue: number;
}

export interface FinAssetMarketValue {
  assetid: number;
  created_at: string;
  created_by: number;
  flagupdatefv: boolean;
  mvid: number;
  mvsource: string;
  startdate: string;
  valueamount: number;
}

export interface AssetRepossessionResponse {
  repid: number;
  assetid: number;

  repdecision: string;
  repdecisionlabel: string;
  repevaldate: string;
  assetfinrvamount: number;
  assetirvamount: number;
  marketvalue: number;
  marketvaluedate: number;
  marketvalueorigin: string;
  damage: string;
  recondamount: number;
  transportamount: number;
  storageamount: number;
  marketvalueasis: number;
  saleamount: number;
  gainifrecond: number;
  gainifsale: number;
  repcomment: string;
}

export interface GetFinConElementByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getFinConElementByAssetID
 */
export function getFinConElementByAssetID(
  params: GetFinConElementByAssetIDParams
) {
  return request.get<AbstractResponse<unknown, FinAssetConElementResponse>>(
    `${URL}/api/finassets/${params.assetid}/conelements`
  );
}

export interface GetDepreciationListByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getDepreciationListByAssetID
 */
export function getDepreciationListByAssetID(
  params: GetDepreciationListByAssetIDParams
) {
  return request.get<AbstractResponse<unknown, FinAssetDeprContextResponse>>(
    `${URL}/api/finassets/${params.assetid}/depreciation`
  );
}

/**
 * @tags Asset Controller
 * @summary getFinAssetListByAnyRef
 */
export function getFinAssetListByAnyRef(params: GetFinAssetListByAnyRefParams) {
  return request.get<AbstractResponse<unknown, FinAssetListSearchResponse>>(
    `${URL}/api/finassets` +
      prepareQueryParams({
        assetid: params.assetid,
        assetreference: params.assetreference,
        assetlabel: params.assetlabel,
        clientname: params.clientname,
        clientreference: params.clientreference,
        ctreference: params.ctreference,
        deliveryreference: params.deliveryreference,
        orderreference: params.orderreference,
        propreference: params.propreference,
        refsupplier: params.refsupplier,
        status: params.status,
        phase: params?.phase,
        suppliername: params.suppliername,
        chassisno: params.chassisno,
        plateno: params.plateno,
        assetclass: params.assetclass,
      } as any)
  );
}

export interface CreateFinAssetParams {
  assetRequest: FinAssetRequest;
}

/**
 * @tags Asset Controller
 * @summary createFinAsset
 */
export function createFinAsset(params: CreateFinAssetParams) {
  return request.post<AbstractResponse<FinAsset, unknown>>(
    `${URL}/api/finassets`,
    params.assetRequest
  );
}

export interface GetFinAssetsByIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getFinAssetsByID
 */
export function getFinAssetsByID(params: GetFinAssetsByIDParams) {
  return request.get<AbstractResponse<FinAssetResponse, unknown>>(
    `${URL}/api/finassets/${params.assetid}`
  );
}

export interface UpdateFinAssetParams {
  assetRequest: FinAssetRequest;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary updateFinAsset
 */
export function updateFinAsset(params: UpdateFinAssetParams) {
  return request.put<AbstractResponse<FinAsset, unknown>>(
    `${URL}/api/finassets/${params.assetid}`,
    params.assetRequest
  );
}

export interface GenerateDeprScheduleParams {
  assetNetamount: number;
  assetType: string;
  assetid: number;
  ctduration: number;
  deliveryDate: string;
  hasComponents: boolean;
  prcode: string;
  residualValue: number;
  rounding: number;
}

/**
 * @tags Asset Controller
 * @summary generateDeprSchedule
 */
export function generateDeprSchedule(params: GenerateDeprScheduleParams) {
  return request.post<AbstractResponse<unknown, FinAssetDeprContextResponse>>(
    `${URL}/api/finassets/${params.assetid}/depreciation` +
      prepareQueryParams({
        assetNetamount: params.assetNetamount,
        assetType: params.assetType,
        ctduration: params.ctduration,
        deliveryDate: params.deliveryDate,
        hasComponents: params.hasComponents,
        prcode: params.prcode,
        residualValue: params.residualValue,
        rounding: params.rounding,
      } as any)
  );
}

export interface GetMarketValueListByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getMarketValueListByAssetID
 */
export function getMarketValueListByAssetID(
  params: GetMarketValueListByAssetIDParams
) {
  return request.get<AbstractResponse<unknown, FinAssetMarketValue>>(
    `${URL}/api/finassets/${params.assetid}/marketvalue`
  );
}

export interface AddMarketValueParams {
  assetid: number;
  marketValue: FinAssetMarketValue;
}

/**
 * @tags Asset Controller
 * @summary addMarketValue
 */
export function addMarketValue(params: AddMarketValueParams) {
  return request.post<AbstractResponse<FinAssetMarketValue, unknown>>(
    `${URL}/api/finassets/${params.assetid}/marketvalue`,
    params.marketValue
  );
}

export interface UpdateMarketValueParams {
  assetid: number;
  marketValue: FinAssetMarketValue;
  mvid: number;
}

/**
 * @tags Asset Controller
 * @summary updateMarketValue
 */
export function updateMarketValue(params: UpdateMarketValueParams) {
  return request.put<AbstractResponse<FinAssetMarketValue, unknown>>(
    `${URL}/api/finassets/${params.assetid}/marketvalue/${params.mvid}`,
    params.marketValue
  );
}

export interface AssetUseValuesRequest {
  assetid: number;
  attcode: string;
  creationdate: string;
  flagupdatefv: boolean;
  flagupdatemv: boolean;
  newmarketvalue: number;
  proctaskid: number;
  useid: number;
  useridcreation: number;
  usevalue: number;
  usevaluedate: string;
  valueid: number;
}

export interface AssetUseValuesResponse {
  assetid: number;
  attcode: string;
  creationdate: string;
  flagupdatefv: boolean;
  flagupdatemv: boolean;
  newmarketvalue: number;
  proctaskid: number;
  useid: number;
  useridcreation: number;
  usevalue: number;
  usevaluedate: string;
  valueid: number;
}
export interface AssetUseResponse {
  assetid: number;
  attcode: string;
  condid: number;
  defaultvalue: number;
  id: number;
  initmarketvalue: number;
  lastregistredusedate: string;
  lastregistredusevalue: number;
  maxvalue: number;
  minvalue: number;
  newmarketvalue: number;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  prcode: string;
  prcodeLabel: string;
  priidexceed: number;
  priidexceedLabel: string;
  priidexceedlabel: string;
  useLabel: string;
  useValues: Array<AssetUseValuesResponse>;
  useid: number;
  uselabel: string;
  usestatus: string;
  useunitperiod: string;
  useunitperiodlabel: string;
  useunittype: string;
  useunittypelabel: string;
  usevalue: number;
  usevaluedate: string;
  usevaluetype: string;
}
export interface GetAssetUseByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetUseByAssetID
 */
export function getFinAssetUseByAssetID(params: GetAssetUseByAssetIDParams) {
  return request.get<AbstractResponse<object, AssetUseResponse>>(
    `${URL}/api/finasset/assetuse/${params.assetid}`
  );
}

export interface AddAssetUseValueParams {
  request: AssetUseValuesRequest;
}

export function addFinAssetUseValue(params: AddAssetUseValueParams) {
  return request.post<AbstractResponse<AssetUseValuesResponse, object>>(
    `${URL}/api/finasset/assetuse/values/add`,
    params.request
  );
}

export interface DeleteMarketValueParams {
  assetid: number;
  mvid: number;
}

/**
 * @tags Asset Controller
 * @summary deleteMarketValue
 */
export function deleteMarketValue(params: DeleteMarketValueParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/finassets/${params.assetid}/marketvalue/${params.mvid}`
  );
}

export interface GetAssetValuesParams {
  assetid: number;
  valuedate: string;
}

/**
 * @tags Asset Controller
 * @summary getAssetValues
 */
export function getAssetValues(params: GetAssetValuesParams) {
  return request.get<AbstractResponse<AssetValues, object>>(
    `${URL}/api/finasset/${params.assetid}/assetvalues/${params.valuedate}`
  );
}
export interface ViewEntityAddAttributeResponse {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attbooleanvalue: boolean;
  attcode: string;
  attlabel?: string;
  attcodeparent: string;
  attdatatype: string;
  attinputtype: string;
  attnbrows: number;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  colspan: number;
  defautvalue: string;
  displayorder: number;
  displayposition: string;
  displaysection: string;
  displaytype: string;
  entity: string;
  entityid: number;
  entitytype: string;
  maxvalue: string;
  minvalue: string;
  parcode: string;
  prcode: string;
  style: string;
}

export interface GetEntityAdditionaAttributesParams {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetsegment: string;
  assetmodel: string;
  entity: string;
  entityid: number;
  entitytype: string;
  prcode: string;
}

export interface AssetFeesResponse {
  assetid: number;
  feescategory: string;
  feescategorylabel: string;
  feescreationdate: string;
  feesdescription: string;
  feesdiscountamount: number;
  feesdiscountrate: number;
  feesid: number;
  feesnetamount: number;
  feesoriginalnetamount: number;
  feesstatus: string;
  feesstatusdate: string;
  feesstatuslabel: string;
  feestaxamount: number;
  feestype: string;
  feestypelabel: string;
  feesuserid: number;
  feesvaluedate: string;
  fessgrossamount: number;
  flagrebilling: boolean;
  picture1after: string;
  picture1before: string;
  picture2after: string;
  picture2before: string;
  picture3after: string;
  picture3before: string;
  suppliername: string;
  supplierreference: string;
  taskid: number;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
}

/**
 * @tags Asset Controller
 * @summary getEntityAdditionaAttributes
 */
export function getFinAssetAdditionalAttributes(
  params: GetEntityAdditionaAttributesParams
) {
  return request.get<AbstractResponse<object, ViewEntityAddAttributeResponse>>(
    `${URL}/api/finasset/additionalattribute` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        assettype: params.assettype,
        assetsegment: params.assetsegment,
        assetmodel: params.assetmodel,
        entity: params.entity,
        entityid: params.entityid,
        entitytype: params.entitytype,
        prcode: params.prcode,
      } as any)
  );
}

export interface GetAssetRepossessionListByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getDepreciationListByAssetID
 */
export function getAssetRepossessionListByAssetID(
  params: GetAssetRepossessionListByAssetIDParams
) {
  return request.get<AbstractResponse<unknown, AssetRepossessionResponse>>(
    `${URL}/api/finasset/${params.assetid}/assetRepossession`
  );
}

export interface GetFinAssetFeesListByAssetidParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getFinAssetFeesListByAssetid
 */
export function getFinAssetFeesListByAssetid(
  params: GetFinAssetFeesListByAssetidParams
) {
  return request.get<AbstractResponse<object, AssetFeesResponse>>(
    `${URL}/api/finasset/assetFees/${params.assetid}`
  );
}
